<template>
  <div v-if="data">
    <div class="flex items-center justify-between">
      <div>
        <Option :items="items" :option.sync="current_option"></Option>
      </div>
      <div>
        <Search @search="search" :placeholder="$t('商品名称/关键词')"></Search>
      </div>
    </div>
    <div v-if="data.total">
      <div class="mt-12">
        <List :span="5" :data="data" #default="{ item }">
          <FavoriteItem :item="item" @del="del" @add="add"></FavoriteItem>
        </List>
      </div>
      <div class="mt-13" v-if="data.total >= 10">
        <el-pagination background layout="prev, pager, next" :total="data.total" :page-size="10"
          :current-page.sync="current_page" :hide-on-single-page="true"></el-pagination>
      </div>
    </div>
    <div v-else class="mt-60">
      <img :src="require(`@/assets/image/暂无收藏.png`)" class="mx-auto" />
    </div>
  </div>
</template>
<script>
import FavoriteItem from "@/components/base/favoriteItem.vue";
import Search from "@/components/mine/search.vue";
import Option from "@/components/mine/favorite/option.vue";
import {
  reactive,
  ref,
  onMounted,
  watch,
  computed,
} from "@vue/composition-api";
import List from "@/components/base/list.vue";
import { equals } from "ramda";

export default {
  components: { FavoriteItem, Search, Option, List },
  setup(props, ctx) {
    const _callapi = (query) =>
      ctx.root.$callapi("user/getCollectedList", query).then((v) => {
        data.value = v.data;
      });

    const items = reactive({
      全部商品: (page = 1) => _callapi({ tag: "product", page, size: 10 }),
      // 降价: (page = 1) => _callapi({ tag: "product", page, size: 10 }),
      // 下架: (page = 1) => _callapi({ tag: "product", page, size: 10 }),
    });
    const current_option = ref();
    const current_page = ref(1);

    watch(
      [current_option, current_page],
      ([new_option, new_page], [prev_option, prev_page]) => {
        if (equals(new_option, prev_option)) {
          items[new_option](new_page);
        } else {
          items[new_option](1);
          current_page.value = 1;
        }
      }
    );

    const data = ref();
    const flight_id = ref();

    onMounted(async () => {
      const res = await ctx.root.$callapi("user/getCollectedList", {
        tag: "product",
        page: 1,
        size: 10,
      });
      data.value = res.data;
      // flight_id.value = (await ctx.root.$callapi("getDefaultFlight")).data.id;
    });

    const del = async (e) => {
      await ctx.root.$callapi("user/doCollect", {
        model: "product",
        objid: e,
        action: "cancel",
      });
      // data.value.items = reject((v) => equals(prop("objid")(v))(e))(prop("items")(data.value))
      _callapi({ tag: "product", page: 1, size: 10 });
    };
    const add = (e) => {
      const cart_info = computed(() => {
        return ctx.root.$store.state.cart.cart;
      });
      const in_cart = cart_info.value
        .map((item) => item.product.id)
        .filter((item) => item == e);
      const res = in_cart.length
        ? ctx.root.$toast(ctx.root.$t("商品已存在购物车"), "warning")
        : (async () => {
          await ctx.root.$callapi("trade/editWithCart", {
            pid: e,
            quantity: 1,
          });
          const r = await ctx.root.$callapi("trade/getMyCartList");
          ctx.root.$store.commit("SAVE_CART", r.data);
          ctx.root.$toast(ctx.root.$t("已添加购物车"), "success");
        })();
    };
    const search = async (e) => {
      data.value = e
        ? (
          await ctx.root.$callapi("user/getCollectedList", {
            page: 1,
            size: 10,
            tag: "product",
            q__title__contains: e,
          })
        ).data
        : (
          await ctx.root.$callapi("user/getCollectedList", {
            tag: "product",
            page: 1,
            size: 10,
          })
        ).data;
    };

    return { items, current_option, current_page, data, del, add, search };
  },
};
</script>
<style scoped lang="scss"></style>
